export default __webpack_public_path__ + "static/media/titulo.ade8ac85.png";